import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { CompartViewModel, MeasurementPointsViewModel } from '../model/measurement-points.model';
import { TranslateService } from '../../../translate';
import { AppService } from '../../../app.service';
import { MatDialog } from '@angular/material/dialog';import { CreateMeasurementPointsComponentComponent } from '../create-measurement-points-component/create-measurement-points-component.component';
import { EditMeasurementPointsComponentComponent } from '../edit-measurement-points-component/edit-measurement-points-component.component';

import { NotificationsService } from 'angular2-notifications';
import { MeasurementPonitsService } from '../services/measurement-points-service';
import { LoadingService } from '../../../shared/services/loading.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-measurement-points-detail',
  templateUrl: './measurement-points-detail.component.html',
  styleUrls: ['./measurement-points-detail.component.scss'], animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({ transform: 'translateY(25%)', opacity: 0 }),
          animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
        ]),
        transition(':leave', [
          style({ transform: 'translateY(0)', opacity: 1 }),
          animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
        ])
      ]
    )]
})
export class MeasurementPointsDetailComponent implements OnInit {
  private _subscriptions: Subscription[] = [];

  UOM:boolean=false;
  compartViewModel: CompartViewModel;
  measurementPoints: MeasurementPointsViewModel[];
  compartId: string;
  componentTypePlusName: string;
  constructor(
    private _measurementPointsService: MeasurementPonitsService,
    private _route: ActivatedRoute,
    private _translate: TranslateService,
    private _appService: AppService,
    private _dialog: MatDialog,
    private _loading: LoadingService,
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
  ) {

  }

  ngOnInit() {
    this._appService.setPageTitle('Measurement Points');
    this.compartId = this._route.snapshot.params.id;
    this.loadMeasurementPoints();
  }

  loadMeasurementPoints() {
    this._loading.startLoading();
    this._subscriptions.push(this._measurementPointsService.getCompartMeasurementPoints(+this.compartId).subscribe(r => {
      this.compartViewModel = r.Compart;
      this.measurementPoints = r.MeasurementPointsViewModels;
      this.componentTypePlusName = r.Compart.CompartType + "(" + r.Compart.CompartName + ")";
      this._loading.finishedLoading();
      console.log("measurementPoints", this.measurementPoints)
    }));
  }

  getImage(MPId:number){
    this._measurementPointsService.GetMeasurementPointImage(MPId).subscribe(res=>{
      //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${res}`);
      //return 'data:image/*;base64,' + res;
    })
  }
  addMeasurementPoints(compartInfo:CompartViewModel) {
    var lastorder = 0;
    if (this.measurementPoints.length >= 1)
      lastorder = this.measurementPoints[this.measurementPoints.length - 1].Order;
    let createNewMP = this._dialog.open(CreateMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        order: lastorder,
        compartId: this.compartId,
        compType:compartInfo.CompartType,
        compName:compartInfo.CompartName,
      }
    });

    createNewMP.afterClosed().subscribe(createPop => {
      if (createPop == undefined)
        return;
      if (createPop > 0)
        this.loadMeasurementPoints();
    });

  }

  editMeasurementPoints(measurementPoint: MeasurementPointsViewModel) {
    let editMP = this._dialog.open(EditMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        compartId: this.compartId,
        measurementPointObj: measurementPoint,
        makeId: this.compartViewModel.MakeId,
        
       
      }
    });

    editMP.afterClosed().subscribe(editMP => {
      if (editMP) {
        this.loadMeasurementPoints();
      }
    });
  }

  UpdateMP(point,compartInfo:CompartViewModel){
    var lastorder = 0;
    if (this.measurementPoints.length >= 1)
      lastorder = this.measurementPoints[this.measurementPoints.length - 1].Order;
    let createNewMP = this._dialog.open(CreateMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        order: lastorder,
        compartId: this.compartId,
        existingPoint:point,
        compType:compartInfo.CompartType,
        compName:compartInfo.CompartName,

      }
    });

    createNewMP.afterClosed().subscribe(createPop => {
      if (createPop == undefined)
        return;
      if (createPop > 0)
        this.loadMeasurementPoints();
    });
  }


  changeMeasurementPointStatus(status: boolean, measurement: MeasurementPointsViewModel) {
    if (measurement.isDisabled != status) {
      this._measurementPointsService.changeMeasurementPointStatus(status, measurement.MeasurementPonitId).subscribe(r => {
        if (r.m_Item1 < 0) {
          this._notify.error("Change active status has been unsuccessful");
        }
        else {
          measurement.isDisabled = status;
          this._notify.success("Change active status has been successful");
        }
      });
    }
  }
  ConvertUOM(event:any){
    console.log("UOM",event.target.value,this.UOM)
    if(this.UOM==true){
      this.measurementPoints.map(x=>{
        x.StartingDim =( x.StartingDim * 25.4)
        x.EndingDim =( x.EndingDim * 25.4)

      })
    }else{
      this.measurementPoints.map(x=>{
        x.StartingDim =( x.StartingDim / 25.4)
        x.EndingDim =( x.EndingDim / 25.4)

      })
    }
  }

  private _userLanguage: string = "english";

  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }


  isFirstComponentInList(item, index) {
  
    if (this.measurementPoints.indexOf(item) == 0) {
        return true;
    }
    return false;
  }
  
  isLastComponentInList(item, index) {
    if (this.measurementPoints.indexOf(item) == this.measurementPoints.length - 1) {
        return true;
    }
    return false;
  }


  // OrderUP(order:number,id:number){
  //   console.log("info.",order,id )
  //   this._measurementPointsService.OrderUp_MeasurementPoint(+this.compartId,order).subscribe(res=>{
  //     this.loadMeasurementPoints();
  //   })
  // }
  // OrderDown(order:number,id:number){

  //   console.log("info__.",order,id )

  //   this._measurementPointsService.OrderDown_MeasurementPoint(+this.compartId,order).subscribe(res=>{
  //     this.loadMeasurementPoints();
  //   })
  // }

}
